import React from "react";
import Categories from "../Components/Categories";
import MenuItems from "../Components/MenuItems";
import Tittle from "../Components/Tittle";
import portfolios from "../Components/allportfolios";
import { useState } from "react";

let allPortfolioCategories = new Set();

const getPortfolioCategories = (allPortfolioCategories) => {
  for (let i = 0; i < portfolios.length; i++) {
    console.log(portfolios[i].category);
    portfolios[i].category.forEach((cat) => allPortfolioCategories.add(cat));
    // allPortfolioCategories.add(...portfolios[i].category);
    console.log(allPortfolioCategories);
  }
  const allCategories = ["All", ...allPortfolioCategories];
  console.log(allCategories);
  return allCategories;
};

// const allCategories = [
//   "All",
//   ...new Set(portfolios.map(item=>item.category))
// ];

function ProjectsPage() {
  // const [categories, setCategories] = useState(allCategories);
  const [categories, setCategories] = useState(
    getPortfolioCategories(allPortfolioCategories)
  );

  const [menuItems, setMenuItems] = useState(portfolios);

  const filter = (category) => {
    if (category === "All") {
      setMenuItems(portfolios);
      return;
    }
    const filteredData = portfolios.filter((item) => {
      return item.category.includes(category);
    });
    setMenuItems(filteredData);
  };

  return (
    <div className="PortfolioPage">
      <div className="title">
        <Tittle title={"Projects"} span={"Projects"} />
      </div>
      <div className="portfolios-data">
        <Categories filter={filter} categories={categories} />
        <MenuItems menuItem={menuItems} />
      </div>
    </div>
  );
}

export default ProjectsPage;
